export default "__VITE_ASSET__CxQA2WD___"